import { render } from "./Loding.vue?vue&type=template&id=183c5419"
import script from "./Loding.vue?vue&type=script&lang=js"
export * from "./Loding.vue?vue&type=script&lang=js"

import "./Loding.vue?vue&type=style&index=0&id=183c5419&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__